import type { IconProps } from "./Icon.types"
import { OrderedList } from "./svg-icons"
import "./Icon.css"

export const Icon = ({ name, state = "outline", color, size }: IconProps) => {
  const IconStates = {
    outline: "rs",
    solid: "ss",
    elegant: "ts",
  }

  if (name === "list-ol") {
    return (
      <OrderedList
        color={color ? color : "inherit"}
        size={size}
      />
    )
  } else {
    return (
      <i
        className={`fi fi-${IconStates[state]}-${name} flex items-center justify-center`}
        style={{
          color: color ? `hsl(var(--${color}))` : "inherit",
          fontSize: `${size}px`,
        }}
      />
    )
  }
}
